@if (pixPayment(); as payment) {
  <app-pix-finish-panel [payment]="payment" />
}
